module.exports = __webpack_public_path__ + "img/logo.da78883e.png";